import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",

  "& .cropContainer": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
  },

  "& .previewContainer": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    "& > .MuiTypography-root": {
      color: "#fff",
      fontWeight: 500,
      ...theme.applyStyles("light", { color: "grey", fontWeight: 700 }),
    },
    "& > img": {
      display: "block",
      width: "11.25rem !important",
      height: "11.25rem !important",
    },
  },
  "& .cropperWrapper": {
    position: "relative",
    width: "100%",
    height: "12.5rem",
    maxWidth: "12.5rem",
    "& .reactEasyCrop_CropArea": {
      border: "2px solid #fff",
      boxShadow: "0 0 2000px 2000px rgb(0 0 0 / 50%)",
    },
  },
  "& .sliderWrapper": {
    width: "100%",
    maxWidth: "10.625rem",
    margin: "0.625rem 0",
    "& .MuiSlider-root": {
      padding: "0.3125rem 0",
    },
  },
  "& .controls": {
    display: "flex",
    alignItems: "center",
    "& .MuiIconButton-root": {
      padding: "0 0.5rem",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    "& .cropContainer": {
      marginBottom: "2rem",
    },
  },
}));
export default StyledBox;
